import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'dx-session-expired-modal',
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.scss']
})
export class SessionExpiredModalComponent implements OnInit {
  waiting = false;
  error: any;

  constructor( private activeModal: NgbActiveModal,private authService:AuthService) {}

  ngOnInit() {}

  login() {
    this.waiting = true;
    this.error = null;
    this.authService.loginWithRedirect().subscribe(
      () => {
        this.activeModal.close();
      },
      (error) => {
        this.handleError(error);
      },
      () => {
        this.waiting = false;
      }
    ); // Using login method from KongAuthService
  }

  handleAuthResult(success: boolean) {
    if (success) {
      this.activeModal.close();
    } else {
      this.error = 'Login failed';
      this.waiting = false;
    }
  }

  private handleError(error: any) {
    this.error = error;
    this.waiting = false;
  }
}
